export const TRANSLATIONS_MAP: Record<number, string> = {
    35651: 'playtech.mobile.system.limits.setBetLimitsError.',
    35648: 'playtech.mobile.system.limits.setLossLimitsError.',
    89900: 'playtech.mobile.system.limits.setDepositLimitsError.'
};
